import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import type { FormControl } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  BadgeComponent,
  FormFieldComponent,
  LabelComponent,
  SelectComponent,
} from '@core/user-interface-legacy';
import type { SelectGroupedOptions, SelectOptionValue } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-form-control',
  templateUrl: './evaluation-form-control.component.html',
  styleUrl: './evaluation-form-control.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    FormFieldComponent,
    LabelComponent,
    SelectComponent,
    BadgeComponent,
  ],
})
export class EvaluationFormControlComponent<T extends SelectOptionValue = SelectOptionValue> {
  public readonly control = input.required<FormControl<T>>();
  public readonly groupedForms = input<SelectGroupedOptions[]>([]);
  public readonly disabled = input<boolean>(false);
}
